var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3817 4.11393C14.1169 4.06112 13.9 3.89549 13.788 3.65865C12.5478 1.0414 9.67288 -0.422058 6.79958 0.107634C4.18153 0.587717 2.12917 2.67768 1.69149 5.30934C1.56187 6.08627 1.57147 6.86401 1.7179 7.62174C1.76591 7.86898 1.65949 8.14423 1.44105 8.34267C0.524891 9.17561 0 10.3622 0 11.5992C0 14.0253 1.97394 16 4.40077 16H13.2023C16.5117 16 19.2033 13.3083 19.2033 9.99896C19.2033 7.14646 17.1758 4.67083 14.3817 4.11393ZM12.0989 9.36444C11.9429 9.52047 11.738 9.59889 11.5332 9.59889C11.3284 9.59889 11.1235 9.52047 10.9675 9.36444L9.60167 7.99861V11.9993C9.60167 12.4418 9.24321 12.7994 8.80153 12.7994C8.35985 12.7994 8.00139 12.4418 8.00139 11.9993V7.99861L6.63555 9.36444C6.3227 9.6773 5.81701 9.6773 5.50416 9.36444C5.1913 9.05159 5.1913 8.5459 5.50416 8.23305L7.67014 6.06707C7.97899 5.75822 8.38466 5.60299 8.79033 5.60059L8.80153 5.59819L8.81273 5.60059C9.2192 5.60299 9.62407 5.75822 9.93293 6.06707L12.0989 8.23305C12.4118 8.5459 12.4118 9.05159 12.0989 9.36444Z",
    fill: "#0C8CE9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6fc8de7be48719a1692475f3691c4b37.svg";
export { ForwardRef as ReactComponent };